import { HeroContext } from '$components/Hero/context';
import { SplitTextMulti } from '$components/SplitTextMulti/SplitTextMulti';
import { useFragment } from '$contentful-gql/fragment-masking';
import { textFragment } from '$providers/common';
import { IHeroSlide } from '$root/src/components';
import cn from 'classnames';
import { HTMLAttributes, useContext, useEffect, useState } from 'react';

export function Titles(props: IHeroSlide & HTMLAttributes<HTMLElement>) {
  const { titles, num } = props;
  const useStore = useContext(HeroContext);
  const currentPage = useStore((state) => state.currentPage);

  const [currentTitle, setCurrentTitle] = useState(0);
  const slideText = useFragment(
    textFragment,
    titles[titles.length > 1 ? currentTitle : 0],
  );
  const [useTitle, setUseTitle] = useState(slideText.title);

  useEffect(() => {
    if (titles.length > 1) {
      setTimeout(() => {
        setCurrentTitle(() =>
          currentTitle > titles.length - 2 ? 0 : currentTitle + 1,
        );
      }, 4000);
    }
  });

  useEffect(() => {
    setUseTitle(slideText.title);
  }, [currentTitle, slideText.title]);

  return (
    <div className={`grid-standard m-0`}>
      <div className={` col-span-4 lg:col-span-8`}>
        <h1
          aria-label={useTitle}
          className={cn(
            currentPage === num
              ? titles.length > 1
                ? 'moveTextInOut'
                : 'moveText'
              : '',
            'style-heading-m text-grey-100 dark:text-white pr-4 md:pr-0',
          )}
        >
          <SplitTextMulti
            isHero={true}
            useUnique={true}
            copy={useTitle}
            role="heading"
            speed={titles.length > 1 ? 50 : 25}
            delay={titles.length > 1 ? 0.5 : 1.0}
          />
        </h1>
      </div>
    </div>
  );
}
